import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { Observable } from "rxjs"

@Injectable({
  providedIn: "root",
})
export class FilmsService {
  films: object

  constructor(private http: HttpClient) {}

  getFilms(teenScreen): Observable<any> {
    return this.http.get("/ng/allfilms.json?teenscreen=" + teenScreen)
  }
}
